"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[285],{

/***/ 90285:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _codebuild_output_src1686024941_src_mr_planner_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var choc_ui_paginator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(79398);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(48641);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_codebuild_output_src1686024941_src_mr_planner_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }







const Pagination = _ref => {
  let {
    currentPage,
    perPage,
    total,
    onClick
  } = _ref;
  const router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
  const Prev = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)((props, ref) => /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("a", _objectSpread(_objectSpread({
    ref: ref
  }, props), {}, {
    children: "\u2039"
  })));
  Prev.displayName = "Prev";
  const Next = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)((props, ref) => /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("a", _objectSpread(_objectSpread({
    ref: ref
  }, props), {}, {
    children: "\u203A"
  })));
  Next.displayName = "Next";
  const Backward = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)((props, ref) => /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("a", _objectSpread(_objectSpread({
    ref: ref
  }, props), {}, {
    children: "\xAB"
  })));
  Backward.displayName = "Backward";
  const Forward = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)((props, ref) => /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("a", _objectSpread(_objectSpread({
    ref: ref
  }, props), {}, {
    children: "\xBB"
  })));
  Forward.displayName = "Forward";
  const Page = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)((props, ref) => /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("a", _objectSpread(_objectSpread({
    ref: ref
  }, props), {}, {
    children: props.children
  })));
  Page.displayName = "Page";

  const itemRender = (_, type) => {
    switch (type) {
      case "prev":
        return Prev;

      case "next":
        return Next;

      case "backward":
        return Backward;

      case "forward":
        return Forward;

      case "page":
        return Page;
    }
  };

  const path = `${router.asPath.split('?')[0]}`;
  return total ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .Flex */ .kC, {
    w: "full",
    alignItems: "center",
    justifyContent: "center",
    className: "pagination",
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(choc_ui_paginator__WEBPACK_IMPORTED_MODULE_2__["default"], {
      defaultCurrent: 1,
      current: currentPage,
      total: total,
      pageSize: perPage,
      paginationProps: {
        display: "flex"
      },
      pageNeighbours: 1,
      onChange: onClick,
      colorScheme: "green",
      hideDisabledButtons: true,
      itemRender: itemRender,
      responsive: {
        activePage: true,
        fastBackward: true,
        fastForward: true
      },
      basePath: `${path}?pagina=`
    })
  }) : null;
};

/* harmony default export */ __webpack_exports__["default"] = (Pagination);

/***/ })

}]);